/**
 * 自定义标签 -
 */
import hasPermi from './permission/hasPermi'

const install = function (Vue) {
  Vue.directive('hasPermi', hasPermi) // 用户权限
}

if (window.Vue) {
  window.hasPermi = hasPermi
}

export default install
